var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArchive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#173261"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.84 11.0426H12.16L11.6267 11.98H20.38L19.84 11.0426Z",
    fill: "#173261"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7666 10.3667L21.6933 11.4867C21.8867 11.7133 22 12.0133 22 12.3333V20.6667C22 21.4 21.4 22 20.6667 22H11.3333C10.6 22 10 21.4 10 20.6667V12.3333C10 12.0133 10.1133 11.7133 10.3067 11.4867L11.2267 10.3667C11.4133 10.14 11.6867 10 12 10H20C20.3133 10 20.5866 10.14 20.7666 10.3667ZM12.16 11.0426H19.84L20.38 11.98H11.6267L12.16 11.0426ZM11.3333 13.3333V20.6667H20.6667V13.3333H11.3333Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1495 10.3031L11.1494 10.3032L10.23 11.4225C10.0214 11.6674 9.9 11.9902 9.9 12.3333V20.6667C9.9 21.4552 10.5448 22.1 11.3333 22.1H20.6667C21.4552 22.1 22.1 21.4552 22.1 20.6667V12.3333C22.1 11.9901 21.9786 11.6673 21.7699 11.4223C21.7697 11.4221 21.7695 11.422 21.7693 11.4218L20.8443 10.3037C20.6456 10.054 20.3439 9.9 20 9.9H12C11.6553 9.9 11.3542 10.0545 11.1495 10.3031ZM20.5667 20.5667H11.4333V13.4333H20.5667V20.5667Z",
    stroke: "white",
    strokeWidth: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.05 15V14.95H19H13H12.95V15V16V16.05H13H19H19.05V16V15Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/archive.93974823a364eb69c6306add6b396770.svg";
export { ForwardRef as ReactComponent };